// @ts-nocheck
import React from 'react'
import { NavLink } from 'redux-first-router-link'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'

import styles from './PrimaryCell.module.scss'

export const PrimaryCell = ({
  description = undefined,
  maxWidth = '20rem',
  primary,
  to,
  hasIncreasedHeight,
}) => {
  const hasTo = !R.isNil(to)

  return (
    <Table.Cell type="body" {...{ maxWidth, hasIncreasedHeight }}>
      <Box
        className={styles.content}
        direction="column"
        justify="center"
        tagName="span"
      >
        {hasTo ? (
          <NavLink className={styles.link} to={to}>
            {primary}
          </NavLink>
        ) : (
          <span className={styles.text}>{primary}</span>
        )}
        {description && (
          <span className={styles.description}>{description}</span>
        )}
      </Box>
    </Table.Cell>
  )
}
